import script from "./footerText.vue?vue&type=script&setup=true&lang=ts"
export * from "./footerText.vue?vue&type=script&setup=true&lang=ts"

import "./footerText.vue?vue&type=style&index=0&id=61d9ad1a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61d9ad1a"]])

export default __exports__